import ApiServer from '@/utils/api/ApiServer.js'

export default {
  async fetchProductionBySort (context, { destinationAccountId, contractTypes }) {
    try {
      context.commit('setLoading', true)
      const url = ApiServer.urlFor(['accounts', destinationAccountId, 'productionbysort'], { params: contractTypes })
      const response = await ApiServer.get(url)
      return response.data
    } finally {
      context.commit('setLoading', false)
    }
  },

  async fetchContractSortScaleSummary (context, contractId) {
    try {
      context.commit('setScaleSummaryLoading', true)
      const url = ApiServer.urlFor(['contracts', contractId, 'sortscalesummary'])
      const response = await ApiServer.get(url)
      return response.data
    } finally {
      context.commit('setScaleSummaryLoading', false)
    }
  }
}
